export const allowedFileExtensions = {
  deviceMemory: ['.rcodex', '.rcode', '.gcode'],
  multiPrint: ['.rcode', '.rcodex', '.gcode'],
  googleDrive: ['.rcode', '.rcodex'],
  printouts: ['.jpg', '.jpeg', '.gif', '.png'],
  shouldShowFileProfileProperty: ['.rcodex', '.rcode'],
};
